import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'
import Button from '../../../Atoms/Button'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  flex: 1;
  justify-content: center;
  background-color: ${theme.colours.white};
  padding: 0 ${theme.gutterUnit}px;
`

const getStateStyle = (state) => {
  const base = [
    { borderRadius: theme.headerHeight / 4 },
    { backgroundColor: '#28b1f9' },
    { paddingLeft: theme.gutterUnit },
    { paddingRight: theme.gutterUnit },
    { height: theme.headerHeight / 2 },
    { borderWidth: 0 }
  ]
  switch (state) {
    case 'prev':
      return {
        button: base.concat([
          { opacity: 0.5 }
        ]),
        text: [{ color: theme.colours.white }]
      }
    case 'curr':
      return {
        button: base,
        text: [{ color: theme.colours.white }]
      }
    default:
      return {
        button: base.concat([
          { backgroundColor: theme.colours.white },
          { borderWidth: 2 },
          { borderColor: '#909aa9' }
        ]),
        text: [{ color: '#909aa9' }]
      }
  }
}

export default class RoundSelectButton extends PureComponent {
  render () {
    const { state, label, round, onButtonPress } = this.props
    const { button, text } = getStateStyle(state)
    let onPress = () => {}
    if (state === 'prev' || state === 'curr') {
      onPress = () => {
        onButtonPress(round)
      }
    }
    return (
      <Container>
        <Button styles={button} onPress={onPress}>
          <Text size='s' semibold overrides={text}>{label}</Text>
        </Button>
      </Container>
    )
  }
}
